import styled from 'styled-components';
import { Accordion, Header } from 'semantic-ui-react';

const StyledAccordion = styled(Accordion)`
margin: 20px 0px;
width: 100% !important;
margin-top: 15px;
 .title {
   display: flex;
   align-items: baseline;
   justify-content: space-between;
   color: black !important;
 }
`

const StyledHeader = styled(Header)`
font-size:18px!important
`

export const El = {
  StyledAccordion,
  StyledHeader
}